module.exports = __webpack_public_path__ + "static/media/download.ad8e75d6.svg";